<template>
  <div class="allContent" @click="fullScreenClick">
    <div class="commont_content">
      <div class="main_comment">
        <!-- 主评论头部 -->
        <div class="main_title">
          <div class="main_left">
            <img :src="state.mainComments.avatar" alt="" />
            <img
              src="../../../assets/game/yz_game_commentmonthVip01.png"
              alt=""
              v-show="state.mainComments.vip == '1'"
            />
            <span
              :style="state.mainComments.vip == '1' ? 'color:#FF7517' : ''"
              >{{ state.mainComments.full_name }}</span
            >
            <img
              src="../../../assets/gameCommunity/icon_manager.png"
              alt=""
              v-if="state.officialAdmin == 1"
            />
            <img
              src="../../../assets/gameCommunity/icon_managerOffical.png"
              alt=""
              v-else-if="state.officialAdmin == 3"
            />
          </div>
          <div class="main_right" v-if="state.mainComments.score">
            <img :src="state.scoreGrade" alt="" />
          </div>
        </div>
        <!-- 主评论内容 -->
        <div class="main_content">
          <h3>{{ state.mainComments.title }}</h3>
          <p
            v-html="state.mainComments.content"
            @click.stop="openEditorImg"
          ></p>
        </div>
        <!-- 评论时间+点赞 -->
        <div class="comment_bottom">
          <div class="comment_time">
            <span>1楼 {{ state.mainComments.createtime }}</span>
          </div>
          <div
            class="comment_like"
            @click.stop="likeThisComment(state.mainComments)"
          >
            <img
              src="../../../assets/game/yz_game_likeComunity.png"
              alt=""
              v-if="state.likeArr.includes(state.mainComments.id)"
            />
            <img
              src="../../../assets/game/yz_game_notLikeComunity.png"
              alt=""
              v-else
            />
            <span
              :style="
                state.likeArr.includes(state.mainComments.id)
                  ? 'color:#9C85FB'
                  : ''
              "
              >{{ state.mainComments.good }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="empty"></div>

    <!-- 其他人评论回复 -->
    <div class="review_title">
      <div class="review_left">
        <p>评论</p>
        <span>
          {{ state.commentReply.length }}
        </span>
      </div>
      <div class="review_right" @click="changeCommentSort">
        <!-- <span v-show="state.commentSortFlag">最新</span>   -->
        <!-- <span v-show="!state.commentSortFlag">最热</span> -->
        <!-- <img src="../../../assets/game/yz_game_comunity_hotsort.png" alt=""> -->
      </div>
    </div>
    <!-- 回复内容 -->
    <div class="review_content">
      <!-- 评论回复内容 -->
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, index) in state.commentReply"
          @click.stop="reviewOtherComment(item)"
          :key="index + '_commentReplyFirst'"
        >
          <template #value>
            <div class="user_info" @click="goCommentDetails">
              <div class="user_info_left">
                <img :src="item.avatar" alt="" />
                <img
                  src="../../../assets/game/yz_game_commentmonthVip01.png"
                  alt=""
                  v-show="item.vip == '1'"
                />
                <span :style="item.vip == '1' ? 'color:#FF7517' : ''">{{
                  item.full_name
                }}</span>

                <img
                  src="../../../assets/gameCommunity/icon_manager.png"
                  alt=""
                  v-if="item.officialAdmin == 1"
                />
                <img
                  src="../../../assets/gameCommunity/icon_managerOffical.png"
                  alt=""
                  v-else-if="item.officialAdmin == 3"
                />
              </div>
            </div>

            <div class="user_comment" @click="goCommentDetails">
              <p v-html="item.content"></p>
              <!-- 评论区回复图片 -->
              <img
                :src="item.url"
                alt=""
                v-show="item.url"
                @click.stop="openInagePreview(item.url)"
              />
            </div>

            <div class="user_bottom">
              <div class="user_bottom_left">
                <span>{{ index + 2 }}楼 {{ item.createtime }}</span>
              </div>
              <div class="user_bottom_right">
                <div class="deletComment" v-if="state.deletePermission">
                  <img
                    src="../../../assets/gameCommunity/icon_gameCommunity_delete.png"
                    alt=""
                    @click="deleteComment(item.id)"
                  />
                </div>

                <div class="like" @click.stop="likeThisReviewComment(item)">
                  <img
                    src="../../../assets/game/yz_game_likeComunity.png"
                    alt=""
                    v-if="state.likeArr.includes(item.id)"
                  />
                  <img
                    src="../../../assets/game/yz_game_notLikeComunity.png"
                    alt=""
                    v-else
                  />
                  <span
                    :style="
                      state.likeArr.includes(item.id) ? 'color:#9C85FB' : ''
                    "
                    >{{ item.good }}</span
                  >
                </div>
              </div>
            </div>

            <!-- 回复评论的回复内容 -->
            <div class="other_review">
              <ul>
                <li
                  v-for="(item2, index2) in item.lists.slice(0, 2)"
                  :key="index2 + '-thirdReply'"
                  @click="showMoreReview(item)"
                >
                  <p>
                    {{ item2.full_name }}:<span> {{ item2.content }}</span>
                  </p>
                </li>
                <li v-if="item.lists.length >= 3">
                  <p>查看全部{{ item.number_reply }}条回复</p>
                </li>
              </ul>
            </div>
          </template>
        </van-cell>
      </van-list>

      <!-- 展开评论详细内容 -->
      <van-popup
        v-model:show="state.showBottom"
        closeable
        close-icon="close"
        round
        position="bottom"
        :style="{ height: '80%' }"
        @close="resetReply"
      >
        <div class="reviewBottom">
          <h3>评论回复</h3>
          <div class="commont_content">
            <div class="main_comment">
              <!-- 主评论头部 -->
              <div class="main_title">
                <div class="main_left">
                  <img :src="state.replyCommentDetail.avatar" alt="" />
                  <img
                    src="../../../assets/game/yz_game_commentmonthVip01.png"
                    alt=""
                    v-show="state.replyCommentDetail.vip == '1'"
                  />
                  <span
                    :style="
                      state.replyCommentDetail.vip == '1' ? 'color:#FF7517' : ''
                    "
                  >
                    {{ state.replyCommentDetail.full_name }}
                  </span>

                  <img
                    src="../../../assets/gameCommunity/icon_manager.png"
                    alt=""
                    v-if="state.replyCommentDetail.officialAdmin == 2"
                  />
                  <img
                    src="../../../assets/gameCommunity/icon_managerOffical.png"
                    alt=""
                    v-else-if="state.replyCommentDetail.officialAdmin == 3"
                  />
                </div>
              </div>
              <!-- 主评论内容展开 -->
              <div class="main_content">
                <p>
                  {{ state.replyCommentDetail.content }}
                </p>
                <img
                  :src="state.replyCommentDetail.url"
                  alt=""
                  v-show="state.replyCommentDetail.url"
                />
              </div>
              <!-- 评论时间+点赞 展开-->
              <div class="comment_bottom">
                <div class="comment_time">
                  <span>{{ state.replyCommentDetail.createtime }}</span>
                </div>
                <div
                  class="comment_like"
                  @click.stop="likeThisReviewComment(state.replyCommentDetail)"
                >
                  <img
                    src="../../../assets/game/yz_game_likeComunity.png"
                    alt=""
                    v-if="state.likeArr.includes(state.replyCommentDetail.id)"
                  />
                  <img
                    src="../../../assets/game/yz_game_notLikeComunity.png"
                    alt=""
                    v-else
                  />
                  <span> {{ state.replyCommentDetail.isgood }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="empty"></div>

          <div class="commont_contentDetails">
            <p v-if="state.thirdReplyComment">
              {{ state.thirdReplyComment.length }} 条回复
            </p>
            <p v-else>暂无回复</p>
            <div
              class="commont_content"
              v-for="(item3, index3) in state.thirdReplyComment"
              :key="index3 + 'thirdReplyDetails'"
            >
              <div class="main_comment">
                <!--  三级回复评论头部 -->
                <div class="main_title">
                  <div class="main_left">
                    <img :src="item3.avatar" alt="" />
                    <img
                      src="../../../assets/game/yz_game_commentmonthVip01.png"
                      alt=""
                      v-show="item3.vip == '1'"
                    />
                    <span :style="item3.vip == '1' ? 'color:#FF7517' : ''">
                      {{ item3.full_name }}
                    </span>

                    <img
                      src="../../../assets/gameCommunity/icon_manager.png"
                      alt=""
                      v-if="item3.officialAdmin == 1"
                    />
                    <img
                      src="../../../assets/gameCommunity/icon_managerOffical.png"
                      alt=""
                      v-else-if="item3.officialAdmin == 3"
                    />
                  </div>
                </div>
                <!--  三级回复评论内容 -->
                <div class="main_content">
                  <p @click.stop="replyThirdComment(item3)">
                    <!-- <p> -->
                    {{ item3.content }}
                  </p>
                </div>
                <!-- 三级回复评论时间+点赞 -->
                <div class="comment_bottom">
                  <div class="comment_time">
                    <span>{{ item3.createtime }}</span>
                  </div>
                  <div
                    class="comment_like"
                    @click.stop="likeThisReviewComment(item3)"
                  >
                    <img
                      src="../../../assets/game/yz_game_likeComunity.png"
                      alt=""
                      v-if="state.likeArr.includes(item3.id)"
                    />
                    <img
                      src="../../../assets/game/yz_game_notLikeComunity.png"
                      alt=""
                      v-else
                    />
                    <span>{{ item3.isgood }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>

      <!-- 我的回复   回复区域-->
      <div class="myReview">
        <van-form @submit="onSubmit" ref="formData">
          <van-cell-group>
            <div class="myReview_text">
              <img
                src="../../../assets/game/yz_game_commentDetails_smile.png"
                alt=""
                @click.stop="changeToImg"
              />
              <van-field
                class="inputField"
                center
                :placeholder="state.inputTextDefault"
                type="textarea"
                rows="1"
                autosize
                v-model="state.inputText"
                @click.stop="openInputField"
                name="text"
                ref="inputFieldText"
              />
              <img
                src="../../../assets/game/yz_game_commentDetails_publish.png"
                alt=""
                @click="submitPublish"
              />
            </div>
            <!-- 图片评论区域 -->
            <div class="myReview_img" v-show="state.imgCommentFlag">
              <van-field name="uploader">
                <template #input>
                  <van-uploader
                    v-model="fileList"
                    multiple
                    :after-read="afterRead"
                    :max-count="1"
                    @click.stop="state.imgCommentFlag = true"
                  />
                </template>
              </van-field>
            </div>
            <div class="emojiArea" v-show="state.emojiFlag">
              <emoji @getValue="getEmojiValue" @delEmoji="delEmojiValue" />
            </div>
          </van-cell-group>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import {
  reactive,
  onMounted,
  ref,
  onDeactivated,
  onUnmounted,
  onActivated,
} from "vue";
import { useStore } from "vuex";
import {
  addComment,
  getCommentList2,
  likeComment,
  hideComment,
} from "@/api/yzCommunity";
import { getQueryString } from "@/utils/location";
import Emoji from "../../chat/components/emoji.vue";
import touxiang from "@/assets/touxiang_reset.png";
import { dateChangeFomat } from "@/utils/date";
import { enCodeEmoji, deCodeEmoji, checkmaskWords } from "@/utils/emojiToCode";
import { Dialog } from "vant";
const store = useStore();
const router = useRouter();
const route = useRoute();
const formData = ref(null);
const inputFieldText = ref(null);
const state = reactive({
  loading: false,
  finished: false,
  commentList: [],
  // 展开详细是否打开
  showBottom: false,
  // 图片添加是否打开
  imgCommentFlag: false,
  //排序方式
  commentSortFlag: true,
  inputTextDefault: "请输入回复内容...",
  inputText: "",
  gid: "",
  uid: "",
  username: "",
  mobile: "",
  comments_id: "",

  // 主评论
  mainComments: {
    officialAdmin: 0,
  },
  // 评论回复
  commentReply: [],
  // 评论回复图片
  replyFile: [],
  // 回复的评论id
  replyCommentId: "",
  // 表情输入框是否打开
  emojiFlag: false,

  //是否回复主评论
  replyMainCommentFlag: false,

  // 回复评论详情
  replyCommentDetail: "",
  // 三级评论详情
  thirdReplyComment: "",

  // 已点赞数组
  likeArr: [],

  scoreGrade: "",

  deletePermission: false,

  managerType: 0,
});
// 页面挂载
onMounted(() => {
  // console.log('页面加载-------------')
});
// 页面激活
onActivated(() => {
  state.deletePermission =
    getQueryString("deletePermission") == "true" ? true : false;
  state.gid = getQueryString("gid");
  state.comments_id = getQueryString("comments_id");
  state.replyCommentId = state.comments_id;
  state.loading = false;
  state.finished = false;
  // getCommentSec()
  state.likeArr = [];
  // console.log('评论详情页面激活-------------',state)

  state.uid = getQueryString("uid");
  state.username = getQueryString("username");
  state.mobile = getQueryString("mobile");
  onLoad();
});
// 页面失活
onDeactivated(() => {
  // console.log('评论详情页面失活-------------')
  // 清空数据
  state.mainComments = "";
  state.commentReply = [];
  state.replyCommentId = "";
  state.replyCommentDetail = "";
  state.thirdReplyComment = "";
  state.inputText = "";
  state.imgCommentFlag = false;
  state.emojiFlag = false;
  state.showBottom = false;
  state.inputTextDefault = "请输入回复内容...";
  state.replyMainCommentFlag = false;
  state.commentSortFlag = true;
  page = 1;
});

var reloadFlag = false;
// 刷新
const onLoad = async () => {
  if (reloadFlag) return;
  await getCommentSec();
};

var page = 1;
var totalpage = 1;
// 获取二级列表
const getCommentSec = async () => {
  reloadFlag = true;
  await getCommentList2({
    gid: state.gid,
    uid: state.uid,
    comments_id: state.comments_id,
    sort: state.commentSortFlag ? 0 : 1,
    pagecode: page,
  }).then((response) => {
    reloadFlag = false;
    // console.log("评论详情返回的结果--------", response.data.data);
    if (response.data.code == "1") {
      // totalpage=response.data.data.totalpage
      // if (page > response.data.data.totalpage) {
      //   state.finished = true;
      //   return;
      // }

      // 主评论数据处理
      state.mainComments = response.data.data.main;
      // 遍历主评论对象数据
      for (let key in state.mainComments) {
        switch (key) {
          case "avatar":
            if (!state.mainComments[key]) {
              state.mainComments[key] = touxiang;
            }
            break;
          case "createtime":
            state.mainComments[key] = dateChangeFomat(state.mainComments[key]);
            break;
          case "isgood":
            if (state.mainComments[key] == "1") {
              state.likeArr.push(state.mainComments.id); // 这里似乎有点问题，应该改为 state.mainComments[key].id
            }
            break;
          case "content":
            state.mainComments[key] = deCodeEmoji(state.mainComments[key]);
            break;
          default:
            // 如果 key 不属于上述任何一种情况，可以添加其他处理逻辑
            // ...
            break;
        }
      }
      switch (state.mainComments.score) {
        case "10积分":
          //引入图片
          state.scoreGrade = require("../../../assets/gameCommunity/score10.png");
          break;
        case "20积分":
          state.scoreGrade = require("../../../assets/gameCommunity/score20.png");
          break;
        case "30积分":
          state.scoreGrade = require("../../../assets/gameCommunity/score30.png");
          break;
        default:
          state.scoreGrade = "";
          break;
      }
      // 评论回复数据处理
      let commentreplyCache = response.data.data.lists.reverse();

      // 将返回的带图片的数据转换为链接
      commentreplyCache.forEach((item, index) => {
        if (item.pic) {
          item.pic = JSON.parse(item.pic);
          // console.log('转换后的图片数据----------',item.pic)
          item.url = item.pic.url;
        }
        if (item.isgood == "1") {
          state.likeArr.push(item.id);
        }
        if (item.lists) {
          item.lists.forEach((item2, index2) => {
            if (item2.isgood == "1") {
              state.likeArr.push(item2.id);
            }
            item2.createtime = dateChangeFomat(item2.createtime);
            item2.content = deCodeEmoji(item2.content);
          });
          item.lists = item.lists.reverse();
        }
        item.createtime = dateChangeFomat(item.createtime);
        item.content = deCodeEmoji(item.content);
      });
      state.commentReply = state.commentReply.concat(commentreplyCache);
      if (page > totalpage) {
        state.finished = true;
      }
      page++;
    }
    // console.log("评论详情页面加载-------------", state.mainComments);
  });
  state.loading = false;
};

// 更改评论回复排序
const changeCommentSort = () => {
  // console.log('更改评论回复排序')
  state.commentSortFlag = !state.commentSortFlag;
  state.commentReply = [];
  getCommentSec();
};
// 查看更多回复
const showMoreReview = (item) => {
  // console.log('查看更多回复---------',item)
  state.showBottom = true;
  state.replyCommentDetail = item;
};

// 图片回复评论
const fileList = ref([]);
const afterRead = (file) => {
  // 当设置 mutiple 为 true 时, file 为数组格式，否则为对象格式
  // console.log(file);
  // state.replyFile=file
};

// 点击全屏
const fullScreenClick = () => {
  // console.log('点击全屏')
  // 点击全屏时，收起图片输入
  if (state.imgCommentFlag || state.emojiFlag) {
    state.emojiFlag = false;
    state.imgCommentFlag = false;
  }
  // 输入框失去焦点
  inputFieldText.value.blur();
  state.inputTextDefault = "请输入回复内容...";
  // console.log()
};

const changeToImg = () => {
  switch (true) {
    case state.imgCommentFlag && !state.showBottom:
      // 二级回复状态，打开表情，关闭图片评论
      state.emojiFlag = true;
      state.imgCommentFlag = false;
      break;
    case state.emojiFlag && !state.showBottom:
      // 二级回复状态，关闭表情，打开图片评论
      state.imgCommentFlag = true;
      state.emojiFlag = false;
      break;
    case !state.emojiFlag && state.showBottom:
      // 三级回复状态，打开表情
      state.emojiFlag = true;
      break;
    case state.emojiFlag && state.showBottom:
      // 三级回复状态，关闭表情，不显示图片评论
      state.emojiFlag = false;
      break;
    default:
      // 默认情况，可能需要根据实际需求添加额外的处理
      break;
  }
};

// 回复主评论
const openInputField = () => {
  // console.log('默认回复主评论*------',state.comments_id,state.replyCommentId)
  if (
    state.replyCommentId == state.comments_id &&
    !state.showBottom &&
    !state.emojiFlag
  ) {
    state.imgCommentFlag = true;
  }
};

// 点击回复其他评论
const reviewOtherComment = (item) => {
  if (item.id == state.replyCommentId) {
    resetReply();
    return;
  }

  state.replyCommentDetail = item;
  // console.log('点击回复某条评论detail----------',state.replyCommentDetail)
  state.thirdReplyComment = item.lists;
  state.replyCommentId = item.id;
  // console.log('要回复的评论id-----',state.replyCommentId)
  state.inputTextDefault = "回复@" + item.full_name;
  // inputFieldText.value.focus()
  state.imgCommentFlag = false;

  // 弹出三级评论表
  // state.showBottom=true

  // console.log('要回复的评论id----',state.replyCommentId)
  // console.log('三级评论回复-------',state.thirdReplyComment)
};

const replyThirdComment = (data) => {
  // console.log('三级评论回复-----',data)
  // state.replyCommentId=data.id
  // state.inputTextDefault='回复@'+data.full_name
  // inputFieldText.value.focus()
  // state.inputText='回复@'+data.full_name+":"
};

// 关闭回复其他评论，重置回复数据
const resetReply = () => {
  // console.log('弹出层被关闭了，开始重置数据----')
  state.inputTextDefault = "请输入回复内容...";
  state.replyCommentId = getQueryString("comments_id");
  // console.log('重置后的回复数据------',state.replyCommentId)
};

// 表情输入
const getEmojiValue = (value) => {
  let index = document.querySelector(".van-field__control").selectionStart;
  let str = state.inputText;
  let str1 = str.slice(0, index);
  let str2 = str.slice(index);
  state.inputText = str1 + value + str2;
};

//表情删除
const delEmojiValue = () => {
  let index = document.querySelector(".van-field__control").selectionStart;
  let str = state.inputText;
  let str1 = str.slice(0, index);
  let str2 = str.slice(index);
  state.inputText = str1.slice(0, -2) + str2;
};

// 发送评论
const submitPublish = () => {
  // console.log('回复的评论id----------',state.replyCommentId)
  formData.value.submit();
};
const onSubmit = (values) => {
  if (checkmaskWords(state.inputText)) {
    state.inputText = " ";
    return;
  }
  // console.log(values)
  let file = values.uploader[0];
  let formData = new FormData();
  for (let key in values) {
    formData.append(key, values[key]);
  }
  formData.append("gid", state.gid);
  formData.append("content", encodeURI(enCodeEmoji(state.inputText)));
  formData.append("uid", state.uid);
  formData.append("pid", state.replyCommentId);
  formData.append("username", state.mobile);
  // formData.append('replyImg', file[0].file);

  // 存在图片回复就添加图片，否则就不存在
  if (formData.get("uploader")) {
    formData.append("replyImg", file.file);
    // console.log('图片的formData----------',formData.get('replyImg'))
  }
  // console.log(formData.get('pid'))
  addComment(formData).then((response) => {
    // console.log('发送评论返回的结果------',response)
    if (response.data.a == "1") {
      state.inputText = "";
      Toast(response.data.b);
      // 1s后重新获取评论列表
      setTimeout(() => {
        state.commentReply = [];
        page = 1;
        getCommentSec();
      }, 1000);
    } else {
      Toast(response.data.b);
    }
  });
};

const likeThisReviewComment = (item) => {
  // console.log('点赞评论回复',state.commentReply)
  state.commentReply.forEach((item2, index2) => {
    if (item.id == item2.id) {
      if (item2.isgood == "1") {
        item2.isgood = "0";
        item2.good--;
        state.likeArr.splice(state.likeArr.indexOf(item.id), 1);
      } else {
        item2.isgood = "1";
        item2.good++;
        state.likeArr.push(item.id);
      }
    }
  });

  if (state.thirdReplyComment) {
    state.thirdReplyComment.forEach((item3, index) => {
      if (item.id == item3.id) {
        if (item3.isgood == "1") {
          item3.isgood = "0";
          item3.good--;
          state.likeArr.splice(state.likeArr.indexOf(item.id), 1);
        } else {
          item3.isgood = "1";
          item3.good++;
          state.likeArr.push(item.id);
        }
      }
    });
  }

  likeComment({
    comments_id: item.id,
    uid: state.uid,
  }).then((res) => {
    //   console.log('点赞评论的返回数据---------',res)
    if (item.isgood == "1") {
      Toast("点赞成功");
    } else {
      Toast("取消点赞");
    }
  });
};

// 点赞该评论
const likeThisComment = (item) => {
  // console.log('被点赞评论的id-----------',item)
  likeComment({
    comments_id: item.id,
    uid: state.uid,
  }).then((res) => {
    // console.log('点赞评论的返回数据---------',res)
    if (res.data.a == "1") {
      //如果已经点赞，就取消点赞
      if (state.likeArr.includes(item.id)) {
        state.likeArr.splice(state.likeArr.indexOf(item.id), 1);
        state.mainComments.good--;
      } else {
        state.likeArr.push(item.id);
        state.mainComments.good++;
      }
    }
  });
};
// 打开图片预览
import { ImagePreview, Toast } from "vant";
import { stat } from "fs";
const openInagePreview = (url) => {
  // console.log('打开图片预览')
  ImagePreview([url]);
};
// 给v-html渲染的img标签添加点击事件
const openEditorImg = (e) => {
  // ImagePreview([url]);
  if (e.target.nodeName == "IMG") {
    // console.log('打开图片预览成功')
    ImagePreview([e.target.src]);
  } else {
    if (state.imgCommentFlag) {
      // 如果点击的不是img标签，并且图片输入框显示，就关闭
      state.imgCommentFlag = false;
    }
  }
};

// 隐藏评论
const deleteComment = (id) => {
  // console.log("需要隐藏的评论ID-----------", id);
  Dialog.confirm({
    title: "确认隐藏该评论吗？",
    message: "隐藏之后如需展示，请去后台操作！",
  })
    .then(() => {
      // on confirm
      //   console.log("确认删除帖子，请求接口操作", id);
      hideComment({
        cid: id,
        uid: state.uid,
      }).then((res) => {
        if (res.data.a == "1") {
          Toast("隐藏帖子成功");
          state.finished = false;
          state.loading = false;
          page = 1;
          state.commentReply = [];
          // getComment();
          getCommentSec();
        }
      });
    })
    .catch(() => {
      Toast("取消隐藏帖子");
    });
};
</script>

<style src="../../../styles/van-sticky-nav.css" scoped></style>
<style scoped>
.allContent {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding: 30px 0 0;
}
.commont_content {
  padding: 0 32px;
}
.main_content /deep/ img {
  max-width: 100%;
  margin-top: 32px;
  border-radius: 16px;
}
.main_comment .main_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
.main_comment .main_title .main_left {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: #333;
  font-weight: 500;
}
.main_comment .main_title .main_left img:nth-of-type(1) {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 24px;
}
.main_comment .main_title .main_left img:nth-of-type(2) {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
.main_comment .main_title .main_left img:nth-of-type(3) {
  height: 28px;
  margin-left: 8px;
}
.main_comment .main_title .main_right {
  /* width: 105px; */
  height: 32px;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  color: #333;
  font-size: 16px;
}
.main_comment .main_title .main_right img {
  width: 80px;
  height: 80px;
}
.main_comment .main_content {
  margin-top: 32px;
  font-size: 30px;
  color: #333;
}
.comment_bottom {
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 26px;
  display: flex;
  justify-content: space-between;
  padding: 0 32px 0 0;
}
.comment_bottom .comment_time {
  color: #999999;
  /* padding-left: 100px; */
}
.comment_bottom .comment_like {
  display: flex;
  align-items: center;
  color: #999999;
  position: relative;
}
.main_comment .comment_bottom .comment_like span {
  right: -10px;
  top: -5px;
  position: absolute;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  color: #c6cad3;
}
.comment_bottom .comment_like img {
  width: 36px;
  height: 36px;
  margin-right: 6px;
}
.empty {
  width: 100%;
  height: 16px;
  background-color: #f1f1f1;
}

.review_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
  font-size: 28px;
  margin-top: 32px;
  color: #333333;
}
.review_title .review_left {
  display: flex;
  align-items: center;
  font-size: 32px;
}
.review_left span {
  font-size: 20px;
  margin-left: 8px;
}
.review_title .review_right {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.review_title .review_right img {
  width: 24px;
  height: 24px;
  margin-left: 4px;
  margin-bottom: 4px;
}

/* 评论回复内容 */
.review_content {
  margin-top: 28px;
  padding: 0 32px;
}
.review_content .user_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
  color: #333333;
}

.user_info .user_info_left {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: #333;
  font-weight: 500;
}
.user_info .user_info_left img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 24px;
}
.user_info .user_info_left img:nth-of-type(2) {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  border-radius: 0;
}
.user_info .user_info_left img:nth-of-type(3) {
  height: 28px;
  width: fit-content;
  margin-left: 8px;
  border-radius: 0;
}
.review_content {
  padding-bottom: 200px;
  background-color: #f7f8fa;
}
.review_content .user_comment {
  /* margin-top: 46px; */
  padding-left: 105px;
  font-size: 30px;
  color: #333;
  /* margin: 24px 0 32px 0; */
}
.review_content .user_bottom {
  /* margin-top: 40px; */
  margin-bottom: 30px;
  padding-left: 105px;
  font-size: 26px;
  display: flex;
  justify-content: space-between;
}
.user_bottom .user_bottom_left span {
  color: #999999;
}
.review_content .user_bottom .user_bottom_right {
  display: flex;
}
.review_content .user_bottom .user_bottom_right .deletComment {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
.review_content .user_bottom .user_bottom_right .like {
  display: flex;
  align-items: center;
  position: relative;
  margin-right: 15px;
}
.review_content .user_bottom .user_bottom_right .like span {
  right: -10px;
  top: -15px;
  position: absolute;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  color: #c6cad3;
}
.review_content .user_bottom .user_bottom_right img {
  width: 36px;
  height: 36px;
  margin-right: 4px;
  margin-bottom: 5px;
}
.other_review {
  width: 566px;
  margin-top: 26px;
  margin-left: 105px;
  /* margin-bottom: 30px; */
  font-size: 24px;
  color: #666;
  background-color: #f1f1f1;
  /* padding: 24px 40px 4px 24px; */
  border-radius: 8px;
}
.other_review ul li {
  /* width: 100%; */
  width: 470px;
  /* margin-bottom: 24px; */
  color: #12cec7;
  max-height: 170px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  padding-left: 24px;
  padding-right: 10px;
}
.other_review ul li:nth-of-type(1) {
  padding-top: 24px;
}
.other_review ul li:nth-last-of-type(1) {
  padding-bottom: 28px;
}
.other_review ul li span {
  width: 100%;
  color: #333;
  word-wrap: break-word;
}

/* 我的回复 */
.myReview {
  position: fixed;
  /* bottom: 50px; */
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f7f8fa;
  z-index: 9999;
}
.myReview_text {
  width: 100%;
  height: 150px;
  /* min-height: 68px;
        max-height: 200px; */
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
}
.myReview_text img:nth-of-type(1) {
  width: 56px;
  height: 56px;
}
.myReview_text img:nth-of-type(2) {
  width: 72px;
  height: 72px;
}

.inputField {
  min-height: 72px;
  max-height: 200px;
  border-radius: 8px;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  padding-left: 20px;
  overflow: auto;
  margin: 0 32px;
}

.myReview_img {
  width: 100%;
  padding: 0 36px;
  margin-top: 10px;
}
:deep(.van-uploader__upload) {
  border-radius: 20px;
}

/* 评论回复弹窗 */
:deep(.van-popup) {
  background-color: #f7f8fa;
}
.reviewBottom {
  /* height: 100%; */
  /* padding: 32px 32px 176px 32px; */
  padding-bottom: 200px;
  /* min-height: 200px; */
  min-height: 800px;
  background-color: #f7f8fa;
}
.reviewBottom h3 {
  display: flex;
  justify-content: center;
  font-size: 28px;
  font-weight: 500;
  margin-top: 36px;
  margin-bottom: 32px;
}
.reviewBottom .main_content {
  margin: 0;
  padding: 0 32px 0 100px;
}
.reviewBottom .comment_bottom {
  padding-left: 100px;
  margin-top: 30px;
}
.commont_contentDetails {
  padding-top: 28px;
}
.commont_contentDetails > p {
  font-size: 28px;
  font-weight: 500;
  margin-left: 32px;
  margin-bottom: 28px;
}
:deep(.van-cell) {
  background-color: #f7f8fa;
}
:deep(.van-cell:after) {
  /* position: relative; */
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

/* 表情输入区域 */
.emojiArea /deep/ .emoji {
  padding-left: 50px;
}
.emojiArea /deep/ .emoji ul {
  padding-left: 40px;
}

/* 评论区图片大小限制 */
.user_comment img {
  max-width: 500px;
  max-height: 500px;
  border-radius: 16px;
  margin-top: 10px;
}

:deep(.van-cell-group) {
  background-color: #f7f8fa;
}
.myReview_text :deep(.van-cell) {
  background-color: #fff;
}
:deep(.van-uploader__upload) {
  background-color: #fff;
}
:deep(.van-field__control) {
  color: #333;
}
:deep(.van-overlay) {
  background-color: rgba(102, 102, 102, 0.08);
}
:deep(.van-hairline--bottom::after) {
  border-bottom-width: 0;
}
</style>
<style>
.van-image-preview__swipe {
  background: rgb(0, 0, 0);
  z-index: 999999;
}
.van-popup {
  z-index: 9999 !important;
}
</style>
